import { IPaymentListItemResponse } from "@miplatform/types";
import { BillingCommitmentLabelMap } from "../../accountingConstants";

export const FIELD_WIDTH = 120;

export interface Field {
  label: string;
  fieldKey: string;
  width?: number;
  type?: "date" | "currency" | string;
  valueGetter?: (val: any) => string;
}

export const LIST_CONFIG = {
  fields: [
    { label: "Customer", fieldKey: "customerAccountName" },
    {
      label: "Payment Type",
      fieldKey: "paymentType",
      valueGetter: (row: IPaymentListItemResponse) =>
        (row.paymentType && BillingCommitmentLabelMap[row.paymentType]) ||
        "Unknown",
    },
    { label: "Amount Received", fieldKey: "amount", type: "currency" },
    {
      label: "Unapplied Amount",
      fieldKey: "remainingAmount",
      type: "currency",
    },
    { label: "Deposit Date", fieldKey: "depositDate", type: "date" },
    { label: "Deposited Into", fieldKey: "bankAccountAlias", width: 180 },
  ],
};
